
<template>
    <BreadCrumb PageTitle="Créer un BESC - Étape 3/4" />
    <AddBescStep3 />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddBescStep3 from "@/components/BESC/AddBesc/AddBescStep3.vue"
  
    export default defineComponent({
      name: "AddBescStep3Page",
      components: {
        BreadCrumb,
        AddBescStep3,
      },
    });
  </script>